import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewplanpage',
  templateUrl: './renewplanpage.component.html',
  styleUrls: ['./renewplanpage.component.css']
})
export class RenewplanpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
